<template>
  <el-scrollbar class="side-scrollbar">
    <el-menu
      :default-active="active +''"
      :active="active"
      class="el-menu-vertical-demo"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      @select="menuSelect"
    >
      <menu-item
        v-for="(menuItem,index) in menu"
        :key="menuItem.id"
        :menuItem="menuItem"
        :index="index"
      ></menu-item>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import MenuItem from "./navmenuitem";
import cookies from "js-cookie";

export default {
  components: { MenuItem },
  data() {
    return {
      active: 1,
    };
  },
  props: {
    menu: {
      type: Array,
      required: true,
    },
  },
  created() {
    var selectMenu = cookies.get("selectmenu");
    if (selectMenu != undefined) {
      this.active = parseInt(selectMenu);
    }

    // console.log(this.active);
  },
  mounted: function () {},
  methods: {
    menuSelect(index, indexPath) {
      cookies.set("selectmenu", index);
      // console.log(index + "," + indexPath);
      // alert(index);
    },
  },
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
.side-scrollbar {
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  .el-scrollbar__view {
    height: 100%;
    .el-menu {
      height: 100%;
      border-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/navmenu/index.vue